import IncomingAlert from "./IncomingAlert";

export default IncomingAlert;


// WEBPACK FOOTER //
// /src/components/IncomingAlert/index.js